import hasActiveContracts from '@/mixins/hasActiveContracts'
import currencySymbol from '@/mixins/currencySymbol'

import { ManagerGQL } from '@/graphql/queries'

export default {
  mixins: [hasActiveContracts, currencySymbol],

  apollo: {
    contractList: {
      query: ManagerGQL,
      update: data => data.merchant.manager.partnerContractList,
      skip () { return !this.hasActiveContracts }
    }
  },

  computed: {
    /**
     * @typedef {
     *  'RUB' | 'USD' | 'EUR'
     * } CURRENCY
     */

    /**
     * @typedef {{
     *     id: number
     *     currency: CURRENCY
     *     activeFrom: number
     *     activeTo: number
     *     balance: number
     *     number: number,
     *     fullName: string,
     *     partnerEntity: {
     *       name: string
     *       inn: string
     *       currency: CURRENCY
     *     }
     *   }} Contract
     */
    /**
     * @returns {Contract[]} contracts
     */
    contracts () {
      if (!this.contractList) {
        return []
      }

      return this.contractList.map(contract => {
        return {
          // fullName: `${contract.partnerEntity.name ? contract.partnerEntity.name + ' ' : ''}${contract.partnerEntity.inn}, ${this.currencySymbol(contract.currency)}`,
          fullName: `${contract.partnerEntity.inn}, ${this.currencySymbol(contract.currency)}`,
          ...contract
        }
      })
    },

    /**
     * @typedef {{
     *     id: number
     *     currency: CURRENCY
     *     activeFrom: number
     *     activeTo: number
     *     balance: number
     *     number: number
     *     fullName: string
     *     partnerEntity: {
     *       name: string
     *       inn: string
     *       currency: CURRENCY
     *     }
     *   }} Contract
     */
    /**
     * @returns {Contract[]} contracts
     */
    contractsWithNull () {
      const out = [
        {
          id: null,
          currency: null,
          activeFrom: null,
          activeTo: null,
          balance: null,
          number: null,
          partnerEntity: {
            name: null,
            inn: null,
            currency: null
          },
          fullName: this.$i18n.t('mixins.contracts.all')
        }
      ]
      return [...out, ...this.contracts]
    }
  }
}
